import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router';

import { Button, Image, Label } from 'semantic-ui-react';
import { useBreakpoints } from '$app/common/utils/mediaQueries';

const AccelerateItem = ({ logo, name, tags }) => {
  const history = useHistory();
  const { isMdDown } = useBreakpoints();

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: '#ffffff',
        boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.15)',
        borderRadius: 10,
        padding: 20,
        height: '100%',
      }}
    >
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          css={{
            display: 'flex',
          }}
        >
          {logo ? (
            <div
              css={{
                width: 130,
                height: 110,
                borderRight: '1px solid #E5E5E5',
                paddingRight: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Image src={logo} />
            </div>
          ) : (
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                background: '#e5e5e5',
                borderRadius: 10,
                width: 74,
                height: 74,
              }}
            />
          )}
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '15px',
              flex: 1,
            }}
          >
            <p
              css={{
                fontSize: 18,
                marginBottom: 5,
                color: '#333333',
                fontWeight: 'bold',
                maxWidth: 174,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {name}
            </p>
            <div
              css={{
                display: 'flex',
                flexWrap: 'wrap',
                height: isMdDown ? 'inherit' : 55,
              }}
            >
              {tags?.map(tag => (
                <Label
                  key={tag}
                  basic
                  css={{
                    '&.ui.basic.label': {
                      border: '1px solid #000000',
                      display: 'flex',
                      alignItems: 'center',
                      textTransform: 'uppercase',
                      fontSize: 10,
                      marginBottom: 5,
                      opacity: 0.5,
                      height: 23,
                    },
                  }}
                >
                  {tag}
                </Label>
              ))}
            </div>
            <Button
              content="Explore now"
              onClick={() => history.push(`/company/${name}`)}
              css={{
                '&.ui.button': {
                  background: '#6C2D8A',
                  color: '#fff',
                  width: 'max-content',
                  borderRadius: 5,
                  marginTop: 10,

                  '&:hover': {
                    filter: 'brightness(85%)',
                    background: '#6C2D8A',
                    color: '#fff',
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AccelerateItem.propTypes = {
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default AccelerateItem;
